/* @flow */
import { Container } from 'flux/utils';
import AppUpsellPage from 'user/components/AppUpsellPage.jsx';
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import JoinConfirmSubscriptionModal from 'join/components/JoinConfirmSubscriptionModal.jsx';
import React from 'react';
import GroupStore from 'groups/stores/GroupStore';
import Group from 'entities/Group';
import { mountModal } from 'lib/modal';
import { markSeenClasses } from 'utils/accountCompletionTracker';

type Props = {
  location: Object,
};

type State = {
  group: Group,
};

class AppUpsellPageContainer extends React.Component {
  props: Props;
  state: State;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  }

  // This has to be here in order to get a CurrentUser
  static onEnter(nextState, replaceWith, callback) {
    AuthActions.checkLoggedIn().then(
      () => callback(),
      () => callback(),
    );
  }

  static getStores() {
    return [GroupStore];
  }

  static calculateState() {
    return {
      group: GroupStore.getGroupCreatedDuringSetup(),
    };
  }

  componentWillMount() {
    if (CurrentUser.isSignedIn()) {
      const { join } = this.props.location.query;
      if (join) {
        mountModal(<JoinConfirmSubscriptionModal code={join} />, this);
      }

      AuthActions.setAuthTokenCookie();
    }
  }

  componentDidMount() {
    if (!CurrentUser.isSignedIn()) {
      return;
    }

    if (this.context.router.location.query.path === '/classes') {
      markSeenClasses(CurrentUser.getUser());
    }
  }

  render() {
    return (
      <AppUpsellPage
        group={this.state.group}
        origin={this.context.router.location.query.origin || 'direct'}
        haveAppUrl={this.context.router.location.query.path}
      />
    );
  }
}

export default Container.create(AppUpsellPageContainer);



// WEBPACK FOOTER //
// ./src/user/components/AppUpsellPageContainer.jsx